import React, { useEffect, useRef, useState } from "react";
import { FaRegBell, FaRegUser, FaSquare } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, setcurrentLanguage } from "../Redux/Reducers/authSlice";
import { Link } from "react-router-dom";
import { useSocket } from "../config/SocketContext";
import { authAxios } from "../config/config";
import logo from "../assets/logo.png";
import LanguageSwitcher from "../MyComponents/LanguageSwitcher";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const TopBar = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [shownotifications, setshownotifications] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [Messages, setMessages] = useState([]);
  const { fname, lname } = useSelector((state) => state.auth.user);
  const user = useSelector((state) => state?.auth?.user);
  const dropdownRef = useRef(null);
  
  

  

  

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  

  const handleActiveSubMenu = (item) => {
    setActiveSubMenu((prevItem) => (prevItem === item ? null : item));
    setshownotifications(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveSubMenu(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="topbar--admin fixed top-[0] left-[0] w-full">
        <Link to="/" className="logo--topbar">
          <img src={logo} alt="logo" width={150} />
        </Link>
        <div className="topbar--rightside">
          <ul>
            <li
              className={`menu--item ${
                activeSubMenu === "profile" ? "active--menu" : "active--menu"
              }`}
              onClick={() => handleActiveSubMenu("profile")}
            >
              <FaRegUser />
              {activeSubMenu === "profile" && (
                <div
                  ref={dropdownRef}
                  className={`profile--dropdown ${
                    isRTL ? "-right-28" : "right-0"
                  }`}
                >
                  <ul>
                    <li onClick={handleLogout}>Logout</li>
                    <LanguageSwitcher />
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default TopBar;
